const Input = ({label, name, value = '', handleChange, type = 'text', required = true, disabled = false}) => {
    return (
        <>
            <label htmlFor={name}
                   className="block text-sm font-medium text-gray-700">
                {label}
            </label>
            <input
                id={name}
                disabled={disabled}
                required={required}
                value={value}
                type={type}
                name={name}
                onChange={handleChange}
                className="disabled:cursor-not-allowed mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
            />
        </>
    )
}
export default Input;